<script setup lang="ts">
import { dateZhCN, NConfigProvider, NDialogProvider, NEl, NLoadingBarProvider, NMessageProvider, NNotificationProvider, zhCN } from 'naive-ui';
import { useThemeStore } from './store/modules/theme';

const { themeOverrides } = useThemeStore();
</script>

<template>
  <NConfigProvider
    :theme-overrides="themeOverrides"
    :locale="zhCN"
    :date-locale="dateZhCN"
  >
    <NEl
      tag="div"
      :theme-overrides="themeOverrides"
      class="overflow-hidden"
    >
      <NLoadingBarProvider>
        <NDialogProvider>
          <NNotificationProvider>
            <NMessageProvider>
              <RouterView v-slot="{ Component, route }">
                <Transition
                  name="fade-slide"
                  mode="out-in"
                  appear
                >
                  <Component :is="Component" :key="route.matched[0]?.name ?? 'layout'" />
                </Transition>
              </RouterView>
            </NMessageProvider>
          </NNotificationProvider>
        </NDialogProvider>
      </NLoadingBarProvider>
    </NEl>
  </NConfigProvider>
</template>
